// extracted by mini-css-extract-plugin
module.exports = {"remove-button":"RemoveButton_remove-button__14XDv","remove-button__icon":"RemoveButton_remove-button__icon__3IZtq"};